export default __webpack_public_path__ + "static/media/applications-image-13.f0bb154f.jpg";